import React from "react";

const RetroLinkButton = ({ href, src, alt }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-[#c0c0c0] w-[2.8rem] h-[2.8rem] lg:w-[2.35rem] lg:h-[2.35rem] xl:w-[2.8rem] xl:h-[2.8rem] flex items-center justify-center border-[0.12rem] border-t-white border-l-white border-b-black border-r-black shadow-inner"
      title={alt}
    >
      <img src={src} alt={alt} className="p-2 object-contain" />
    </a>
  );
};

export default RetroLinkButton;
